/**
 * Access Level Constants
 * Defines the hierarchy of access levels in the system
 */
export const ACCESS_LEVEL = {
  REPUBLIC: "republic",
  REGION: "region",
  CITY: "city",
  MAKHALLA: "makhalla",
} as const;

/**
 * Access Level Type
 * Union type of all possible access level values
 */
export type AccessLevel =
  | typeof ACCESS_LEVEL.REPUBLIC
  | typeof ACCESS_LEVEL.REGION
  | typeof ACCESS_LEVEL.CITY
  | typeof ACCESS_LEVEL.MAKHALLA;

/**
 * Array of all access level values
 */
export const ACCESS_LEVELS: readonly AccessLevel[] = [
  ACCESS_LEVEL.REPUBLIC,
  ACCESS_LEVEL.REGION,
  ACCESS_LEVEL.CITY,
  ACCESS_LEVEL.MAKHALLA,
] as const;
